const initializeProduct = (root) => {
  if (root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  const form = root.querySelector(".product-form");
  const mainImage = root.querySelector(".main-product-image");
  const price = root.querySelector("[data-product-price]");
  const mobileBar = document.querySelector("[data-mobile-buy-bar]");
  const mobilePrice = mobileBar?.querySelector("[data-mobile-price]");
  const mobileSubmit = mobileBar?.querySelector("[data-mobile-submit]");
  const addButton = root.querySelector("[data-add-button]");
  const quantity = root.querySelector('[name="quantity"]');

  root.querySelectorAll("[data-product-thumbnail]").forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.removeAttribute("srcset");
      mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
      root.querySelectorAll("[data-product-thumbnail]").forEach((item) => {
        const isSelected = item === thumbnail;
        item.classList.toggle("is-active", isSelected);
        item.setAttribute("aria-pressed", String(isSelected));
      });
    });
  });

  root.querySelectorAll("[data-variant-input]").forEach((input) => {
    input.addEventListener("change", () => {
      const available = input.dataset.variantAvailable === "true";
      if (price) price.textContent = input.dataset.variantPrice;
      if (mobilePrice) mobilePrice.textContent = input.dataset.variantPrice;
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? "Add to cart" : "Sold out";
      }
      if (mobileSubmit) {
        mobileSubmit.disabled = !available;
        mobileSubmit.textContent = available ? "Add to cart" : "Sold out";
      }
      if (mainImage && input.dataset.variantImage) {
        mainImage.src = input.dataset.variantImage;
        mainImage.removeAttribute("srcset");
      }
    });
  });

  const updateQuantity = (change) => {
    if (!quantity) return;
    const minimum = Number(quantity.min) || 1;
    const maximum = Number(quantity.max) || 10;
    const current = Number(quantity.value) || minimum;
    quantity.value = String(Math.min(maximum, Math.max(minimum, current + change)));
  };

  root.querySelector("[data-quantity-decrease]")?.addEventListener("click", () => updateQuantity(-1));
  root.querySelector("[data-quantity-increase]")?.addEventListener("click", () => updateQuantity(1));
  quantity?.addEventListener("change", () => updateQuantity(0));

  mobileSubmit?.addEventListener("click", () => {
    if (!form || mobileSubmit.disabled) return;
    if (form.requestSubmit) {
      form.requestSubmit(addButton);
    } else {
      addButton?.click();
    }
  });

  if (addButton && mobileBar && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      ([entry]) => mobileBar.classList.toggle("is-suppressed", entry.isIntersecting),
      { threshold: 0.7 }
    );
    observer.observe(addButton);
  }
};

const initializeTheme = () => {
  document.querySelectorAll("[data-product-root]").forEach(initializeProduct);
};

document.addEventListener("DOMContentLoaded", initializeTheme);
document.addEventListener("shopify:section:load", initializeTheme);


(() => {
  const initPriceCountdown = () => {
      const countdowns = document.querySelectorAll('[data-price-countdown]:not([data-countdown-ready])');
          if (!countdowns.length) return;
              countdowns.forEach((countdown) => { countdown.dataset.countdownReady = 'true'; });
                  const target = new Date('2026-11-01T00:00:00-07:00').getTime();
                      const pad = (value) => String(value).padStart(2, '0');
                          const update = () => {
                                const remaining = target - Date.now();
                                      if (remaining <= 0) {
                                              countdowns.forEach((countdown) => { countdown.parentElement.textContent = 'New pricing is now live'; });
                                                      return false;
                                                            }
                                                                  const days = Math.floor(remaining / 86400000);
                                                                        const hours = Math.floor((remaining % 86400000) / 3600000);
                                                                              const minutes = Math.floor((remaining % 3600000) / 60000);
                                                                                    const seconds = Math.floor((remaining % 60000) / 1000);
                                                                                          const value = days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
                                                                                                countdowns.forEach((countdown) => { countdown.textContent = value; });
                                                                                                      return true;
                                                                                                          };
                                                                                                              if (update()) window.setInterval(update, 1000);
                                                                                                                };
                                                                                                                  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPriceCountdown);
                                                                                                                    else initPriceCountdown();
                                                                                                                      document.addEventListener('shopify:section:load', initPriceCountdown);
                                                                                                                      })();
                                                                                                                      